import React, { Component } from "react";
import * as Server from "../Server";
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Row,
  Col,
  Button,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { capitalizeFirstLetter } from "../GeneralFunctions";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
class InsuranceClaims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: 0,
      limit: 10,
      insuranceClaims: [],
      totalInsuranceClaims: 0,
      pageNumbers: [],
      dropdownOpen: [],
    };
  }
  componentDidMount() {
    this.getInsuranceClaims();
  }

  getInsuranceClaims = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.request({
        url: "insurance/admin/claimList",
        method: "POST",
        data: { page, pageLimit },
      });
      if (response) {
        this.setState({
          showLoader: false,
          insuranceClaims: response.insuranceClaims,
          totalInsuranceClaims: response.totalInsuranceClaims,
          pages: response.pages,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        let dropdownOpenCheck = [];
        for (let index = 0; index < response.totalInsuranceClaims; index++) {
          dropdownOpenCheck.push(false);
        }
        this.setState({
          pageNumbers: pageNumbers,
          dropdownOpen: dropdownOpenCheck,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateInsuranceClaims = async (event, status, claim) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "insurance/status/update",
        method: "POST",
        data: {
          status: status,
          policyNumber: claim.policyNumber,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getInsuranceClaims();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getInsuranceClaims();
    });
  };

  toggle = (event, index) => {
    event.preventDefault();
    let dropdownOpen = this.state.dropdownOpen;
    dropdownOpen[index] = !this.state.dropdownOpen[index];
    this.setState({ dropdownOpen: dropdownOpen });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Insurance-Claims"
          breadcrumbs={[{ name: "Insurance-Claims", active: true }]}
        >
          <Card>
            <CardHeader>
              <Row>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex">
                    <div sm={4} className="mt-2 pr-2">
                      <Label>Shown</Label>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        name="pageLimit"
                        onChange={(event) => {
                          this.refreshPagination(1, event.target.value);
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Input>
                    </div>
                    <div sm={4} className="mt-2 pl-2">
                      <Label>entries</Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-center">
                    <div className="mt-2 pr-2">
                      <Label>
                        Showing{" "}
                        {!this.state.totalInsuranceClaims
                          ? 0
                          : this.state.page * this.state.limit -
                            (this.state.limit - 1) +
                            " "}{" "}
                        to{" "}
                        {this.state.page * this.state.limit >
                        this.state.totalInsuranceClaims
                          ? this.state.totalInsuranceClaims
                          : this.state.page * this.state.limit}{" "}
                        of {this.state.totalInsuranceClaims}
                      </Label>
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={12} md={12}>
                  <div className="d-flex justify-content-end">
                    <div sm={4} className="pr-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page <= 1}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page - 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                      </Button>
                    </div>
                    <div sm={4}>
                      <Input
                        type="select"
                        value={this.state.page}
                        name="filter"
                        onChange={(event) => {
                          this.refreshPagination(
                            event.target.value,
                            this.state.limit
                          );
                        }}
                      >
                        {this.state.pageNumbers.length !== 0 ? (
                          this.state.pageNumbers.map((pageNumber, index) => (
                            <option value={pageNumber} key={index}>
                              {pageNumber}
                            </option>
                          ))
                        ) : (
                          <option value={0}>0</option>
                        )}
                      </Input>
                    </div>
                    <div sm={4} className="pl-2">
                      <Button
                        className="rounded-circle"
                        disabled={this.state.page >= this.state.pages}
                        onClick={(event) =>
                          this.refreshPagination(
                            this.state.page + 1,
                            this.state.limit
                          )
                        }
                      >
                        <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Policy Number</th>
                        <th className="ml-5 pl-5">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.insuranceClaims.length > 0 ? (
                        this.state.insuranceClaims.map((claims, index) => (
                          <tr key={index}>
                            <td>{capitalizeFirstLetter(claims.name || "-")}</td>
                            <td>{claims.phone || "-"}</td>
                            <td>{claims.policyNumber || "-"}</td>
                            <td>
                              <Dropdown
                                isOpen={this.state.dropdownOpen[index]}
                                toggle={(event) => this.toggle(event, index)}
                              >
                                <DropdownToggle caret>
                                  <Label
                                    style={{ width: "100px", height: "10px" }}
                                  >
                                    {claims.status === "submitted"
                                      ? "Pending"
                                      : capitalizeFirstLetter(
                                          claims.status || "-"
                                        )}
                                  </Label>
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    onClick={(event) =>
                                      claims.status !== "approved" &&
                                      this.updateInsuranceClaims(
                                        event,
                                        "approved",
                                        claims
                                      )
                                    }
                                  >
                                    Approve
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={(event) =>
                                      claims.status !== "rejected" &&
                                      this.updateInsuranceClaims(
                                        event,
                                        "rejected",
                                        claims
                                      )
                                    }
                                  >
                                    Reject
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={(event) =>
                                      claims.status !== "processing" &&
                                      this.updateInsuranceClaims(
                                        event,
                                        "processing",
                                        claims
                                      )
                                    }
                                  >
                                    Processing
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No Claims found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}

export default InsuranceClaims;
